import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import api from '../../../config/configApi';

export function RedefinirSenha() {
  const history = useHistory();
  const { state } = useLocation();

  const [form, setForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [status, setStatus] = useState({
    type: '',
    mensagem: state?.mensagem || 'Sua senha expirou. Redefina sua senha para continuar.',
    loading: false,
  });

  const valorInput = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const alterarSenha = async (e) => {
    e.preventDefault();

    if (!state?.userId) {
      setStatus({
        type: 'error',
        mensagem: 'Usuário não identificado. Volte para o login e tente novamente.',
        loading: false,
      });
      return;
    }

    setStatus({
      type: '',
      mensagem: '',
      loading: true,
    });

    try {
      const response = await api.put('/login/force-change-password', {
        userId: state.userId,
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
        confirmPassword: form.confirmPassword,
      }, {
        suppressErrorModal: true,
      });

      history.replace('/', {
        type: 'success',
        mensagem: response.data.mensagem,
      });
    } catch (err) {
      setStatus({
        type: 'error',
        mensagem: err.response?.data?.mensagem || 'Erro ao redefinir senha.',
        loading: false,
      });
    }
  };

  return (
    <div id="wrapper">
      <div id="content-wrapper">
        <div id="content">
          <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="container-fluid">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-lg-7 col-md-9">
                    <div className="card o-hidden border-0 shadow-lg my-5">
                      <div className="card-body text-bg-dark p-5">
                        <div className="text-center">
                          <h1 className="h4 mb-4">Redefinir senha</h1>
                        </div>

                        {status.mensagem && (
                          <p className={status.type === 'error' ? 'alert-danger' : 'alert-success'}>
                            {status.mensagem}
                          </p>
                        )}

                        <form onSubmit={alterarSenha}>
                          <div className="form-group">
                            <input
                              type="password"
                              name="currentPassword"
                              className="form-control form-control-user"
                              placeholder="Senha atual"
                              value={form.currentPassword}
                              onChange={valorInput}
                              required
                            />
                          </div>

                          <div className="form-group">
                            <input
                              type="password"
                              name="newPassword"
                              className="form-control form-control-user"
                              placeholder="Nova senha"
                              value={form.newPassword}
                              onChange={valorInput}
                              required
                            />
                          </div>

                          <div className="form-group">
                            <input
                              type="password"
                              name="confirmPassword"
                              className="form-control form-control-user"
                              placeholder="Confirmar nova senha"
                              value={form.confirmPassword}
                              onChange={valorInput}
                              required
                            />
                          </div>

                          <div className="form-group">
                            <button
                              type="submit"
                              className="btn btn-primary btn-user btn-block"
                              disabled={status.loading}
                            >
                              {status.loading ? 'Salvando...' : 'Alterar senha'}
                            </button>
                          </div>

                          <button
                            type="button"
                            className="btn btn-secondary btn-user btn-block"
                            onClick={() => history.push('/')}
                          >
                            Voltar para login
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
